import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppCtrl from "../../../control/AppCtrl";
import useAlert from "../../../hook/useAlert";
import switchFunc from "../../../redux/switchFunc/switchFuncAction";
import useUserCoins from "../../../redux/userCoins/userCoinsAction";
import Config from "../../../utils/Config";
import EFunction from "../../../utils/FunctionPage";
import LANGUAGE_TYPE from "../../../utils/Language";
import styles from "./index.module.scss";
import moment from "moment"; // <- add

function WalletPage() {
  const text = Config.text.walletPage;
  const { setFunc } = switchFunc();
  const { userCoins } = useUserCoins();
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  //===========================================================================
  // Add current time state
  const [nowTime, setNowTime] = useState(moment()); // <- add
  const [canExchangeTrialToFormal, setExchangeTrialToFormal] = useState(false);
  const [canExchangeFormalToTrial, setExchangeFormalToTrial] = useState(false);
  const [canExchangeBetRewardToFormal, setExchangeBetRewardToFormal] =
    useState(false);

  useEffect(() => {
    componentDidMount();
    return componentWillUnmount;
  }, []);

  useEffect(() => {
    const t = setInterval(() => setNowTime(moment()), 1000); // <- add
    return () => clearInterval(t); // <- add
  }, []);

  useEffect(() => {
    const language = AppCtrl.getLanguage();
    const mainSettings = AppCtrl.mainSettings();
    const uiGiftUserName = document.getElementById("walletUserName");
    if (uiGiftUserName) {
      const userInfo = AppCtrl.userInfo();
      if (language == LANGUAGE_TYPE.en_US)
        uiGiftUserName.innerHTML = `User: ${userInfo.nickName()}`;
      else uiGiftUserName.innerHTML = `用戶: ${userInfo.nickName()}`;
    }

    if (userCoins) {
      // show coins data
      const uiUserScores = document.getElementById("walletUserScores");
      if (uiUserScores && userCoins.coins != null) {
        const gold = Config.gold[language];
        uiUserScores.innerHTML = `${gold}: ${userCoins.coins.toString()}`;
      }
      const uiUserTrialScores = document.getElementById(
        "walletUserTrialScores"
      );
      if (uiUserTrialScores && userCoins.trialCoins != null) {
        if (Config.trialCoins) {
          const silver = Config.silver[language];
          uiUserTrialScores.innerHTML = `${silver}: ${userCoins.trialCoins.toString()}`;
        } else {
          uiUserTrialScores.innerHTML = "";
        }
      }
      if (Config.wainZhu) {
        // show wainZhu data
        const uiUserWainZhus = document.getElementById("walletUserWainZhus");
        if (uiUserWainZhus) {
          const wianZhu = Config.wainZhuName[language];
          if (userCoins.wainZhus != null) {
            let wainZhusValue = userCoins.wainZhus.toString();
            if (typeof userCoins.wainZhus === "object")
              wainZhusValue = userCoins.wainZhus.WainZhus.toString();
            uiUserWainZhus.style.display = "";
            uiUserWainZhus.innerHTML = `${wianZhu}: ${wainZhusValue}`;
          } else {
            uiUserWainZhus.style.display = "none";
          }
        }
      }
      if (mainSettings.ShowBetReward) {
        // show betReward data
        const uiUserBetReward = document.getElementById("walletBetReward");
        if (uiUserBetReward && userCoins.betReward != null) {
          const betRewardName = Config.betRewardName[language];
          uiUserBetReward.innerHTML = `${betRewardName}: ${userCoins.betReward.toString()}`;
        }
      }

      if (
        mainSettings.hasOwnProperty("ExchangeRatio") &&
        mainSettings.hasOwnProperty("ExchangeMinLeft") &&
        mainSettings.hasOwnProperty("ExchangeReceiverRate") &&
        mainSettings.hasOwnProperty("MinExchangeBetReward")
      ) {
        const exchangeRatio = parseInt(mainSettings["ExchangeRatio"]);
        const exchangeMinLeft = parseInt(mainSettings["ExchangeMinLeft"]);
        const exchangeReceiverRate = parseInt(
          mainSettings["ExchangeReceiverRate"]
        );
        const minExchangeBetReward = parseInt(
          mainSettings["MinExchangeBetReward"]
        );
        // const maxExchangeBetReward = parseInt(mainSettings["MaxExchangeBetReward"]);

        // fill values for trial to formal
        let validTrialToFormalSilvers = userCoins.trialCoins - exchangeMinLeft;
        if (exchangeReceiverRate != 100)
          validTrialToFormalSilvers = Math.floor(
            (validTrialToFormalSilvers * 100) /
              (100 + (100 - exchangeReceiverRate))
          );
        let maxTrialToFormalGolds =
          validTrialToFormalSilvers > 0
            ? Math.floor(validTrialToFormalSilvers / exchangeRatio)
            : 0;
        let maxTrialToFormalSilvers = maxTrialToFormalGolds * exchangeRatio;
        if (exchangeReceiverRate != 100)
          maxTrialToFormalSilvers =
            maxTrialToFormalSilvers +
            Math.ceil(
              (maxTrialToFormalSilvers * (100 - exchangeReceiverRate)) / 100
            );

        let placeholderAppliedFormal = "";
        if (language == LANGUAGE_TYPE.en_US) {
          placeholderAppliedFormal = `exchange min 1 ${Config.gold[language]}`;
        } else {
          placeholderAppliedFormal = `至少1枚${Config.gold[language]}`;
        }

        setExchangeTrialToFormal(mainSettings.CanExchangeTrialToFormal);
        if (mainSettings.CanExchangeTrialToFormal) {
          let hintTrialToFormal = "<div>";
          if (language == LANGUAGE_TYPE.en_US) {
            //
            hintTrialToFormal += `must more than ${exchangeMinLeft} ${Config.silver[language]} to exchange ${Config.gold[language]}<br>`;
            if (maxTrialToFormalGolds > 0) {
              hintTrialToFormal += `you can exchange ${maxTrialToFormalSilvers} ${Config.silver[language]} to ${maxTrialToFormalGolds} ${Config.gold[language]}`;
            } else {
              hintTrialToFormal += `${exchangeRatio} ${Config.silver[language]} for 1 ${Config.gold[language]}`;
            }
            if (exchangeReceiverRate != 100) {
              hintTrialToFormal += `<br>need to pay ${
                100 - exchangeReceiverRate
              }% total amount for exchanged fee:`;
            }
          } else {
            //
            hintTrialToFormal += `${Config.silver[language]}總額超過${exchangeMinLeft}時才可兌換${Config.gold[language]}<br>`;
            if (maxTrialToFormalGolds > 0) {
              hintTrialToFormal += `最多可用${maxTrialToFormalSilvers} ${Config.silver[language]} 換到 ${maxTrialToFormalGolds} ${Config.gold[language]}`;
            } else {
              hintTrialToFormal += `${exchangeRatio} ${Config.silver[language]} 換 1 ${Config.gold[language]}`;
            }
            if (exchangeReceiverRate != 100) {
              hintTrialToFormal += `<br>兌換需支付總額${
                100 - exchangeReceiverRate
              }%的手續費`;
            }
          }
          hintTrialToFormal += "</div>";
          const uiWalletExchangeTrialToFormalHint = document.getElementById(
            "walletExchangeTrialToFormalHint"
          );
          if (uiWalletExchangeTrialToFormalHint)
            uiWalletExchangeTrialToFormalHint.innerHTML = hintTrialToFormal;
          const uiWalletExchangeTrialToFormalGolds = document.getElementById(
            "walletExchangeTrialToFormalGolds"
          );
          if (uiWalletExchangeTrialToFormalGolds) {
            uiWalletExchangeTrialToFormalGolds.placeholder =
              placeholderAppliedFormal;
            uiWalletExchangeTrialToFormalGolds.disabled =
              maxTrialToFormalGolds > 0 ? false : true;
          }
          const uiBtnWalletExchangeTrialToFormalOk = document.getElementById(
            "btnWalletExchangeTrialToFormalOk"
          );
          if (uiBtnWalletExchangeTrialToFormalOk)
            uiBtnWalletExchangeTrialToFormalOk.disabled =
              maxTrialToFormalGolds > 0 ? false : true;
        }

        setExchangeFormalToTrial(mainSettings.CanExchangeFormalToTrial);
        if (mainSettings.CanExchangeFormalToTrial) {
          // fill values for formal trial
          let maxFormalToTrialGolds = userCoins.coins;
          let maxFormalToTrialSilvers = maxFormalToTrialGolds * exchangeRatio;
          if (exchangeReceiverRate != 100)
            maxFormalToTrialSilvers = Math.floor(
              (maxFormalToTrialSilvers * exchangeReceiverRate) / 100
            );

          let hintFormalToTrial = "<div>";
          if (language == LANGUAGE_TYPE.en_US) {
            if (maxFormalToTrialGolds > 0) {
              hintFormalToTrial += `you can exchange ${maxFormalToTrialGolds} ${Config.gold[language]} to ${maxFormalToTrialSilvers} ${Config.silver[language]}`;
            } else {
              hintFormalToTrial += `1 ${Config.gold[language]} for ${exchangeRatio} ${Config.silver[language]}`;
            }
            if (exchangeReceiverRate != 100) {
              hintFormalToTrial += `<br>need to pay ${
                100 - exchangeReceiverRate
              }% total amount for exchanged fee:`;
            }
          } else {
            if (maxFormalToTrialGolds > 0) {
              hintFormalToTrial += `最多可用${maxFormalToTrialGolds} ${Config.gold[language]} 換到 ${maxFormalToTrialSilvers} ${Config.silver[language]}`;
            } else {
              hintFormalToTrial += `1 ${Config.gold[language]} 換 ${exchangeRatio} ${Config.silver[language]}`;
            }
            if (exchangeReceiverRate != 100) {
              hintFormalToTrial += `<br>兌換需支付總額${
                100 - exchangeReceiverRate
              }%的手續費`;
            }
          }
          hintFormalToTrial += "</div>";
          const uiWalletExchangeFormalToTrialHint = document.getElementById(
            "walletExchangeFormalToTrialHint"
          );
          if (uiWalletExchangeFormalToTrialHint)
            uiWalletExchangeFormalToTrialHint.innerHTML = hintFormalToTrial;
          const uiWalletExchangeFormalToTrialGolds = document.getElementById(
            "walletExchangeFormalToTrialGolds"
          );
          if (uiWalletExchangeFormalToTrialGolds) {
            uiWalletExchangeFormalToTrialGolds.placeholder =
              placeholderAppliedFormal;
            uiWalletExchangeFormalToTrialGolds.disabled =
              maxFormalToTrialGolds > 0 ? false : true;
          }
          const uiBtnWalletExchangeFormalToTrialOk = document.getElementById(
            "btnWalletExchangeFormalToTrialOk"
          );
          if (uiBtnWalletExchangeFormalToTrialOk)
            uiBtnWalletExchangeFormalToTrialOk.disabled =
              maxFormalToTrialGolds > 0 ? false : true;
        }

        setExchangeBetRewardToFormal(mainSettings.ShowBetReward);
        if (mainSettings.ShowBetReward) {
          let maxBetRewardExchanged = Math.floor(
            userCoins.betReward / minExchangeBetReward
          );
          let maxBetRewardCost = maxBetRewardExchanged * minExchangeBetReward;
          let hintBetRewardToFormal = "<div>";
          if (language == LANGUAGE_TYPE.en_US) {
            hintBetRewardToFormal += `the base score is: ${minExchangeBetReward} to exchange ${Config.gold[language]}<br>`;
            if (maxBetRewardExchanged >= 1) {
              hintBetRewardToFormal += `you can exchange ${maxBetRewardCost} bet reward to ${maxBetRewardExchanged} ${Config.gold[language]}`;
            } else {
              hintBetRewardToFormal += `require ${minExchangeBetReward} bet reward for 1 ${Config.gold[language]}`;
            }
          } else {
            hintBetRewardToFormal += `返水基數是${minExchangeBetReward}，超過時才可兌換${Config.gold[language]}<br>`;
            if (maxBetRewardExchanged >= 1) {
              hintBetRewardToFormal += `可用${maxBetRewardCost} 返水 換到 ${maxBetRewardExchanged} ${Config.gold[language]}`;
            } else {
              hintBetRewardToFormal += `至少需 ${minExchangeBetReward} 返水 換 1 ${Config.gold[language]}`;
            }
          }
          hintBetRewardToFormal += "</div>";
          const uiWalletExchangeBetRewardToFormalHint = document.getElementById(
            "walletExchangeBetRewardToFormalHint"
          );
          if (uiWalletExchangeBetRewardToFormalHint)
            uiWalletExchangeBetRewardToFormalHint.innerHTML =
              hintBetRewardToFormal;
          const uiWalletExchangeBetRewardToFormalGolds =
            document.getElementById("walletExchangeBetRewardToFormalGolds");
          if (uiWalletExchangeBetRewardToFormalGolds) {
            uiWalletExchangeBetRewardToFormalGolds.placeholder =
              placeholderAppliedFormal;
            uiWalletExchangeBetRewardToFormalGolds.disabled =
              maxBetRewardExchanged > 0 ? false : true;
          }
          const uiBtnWalletExchangeBetRewardToFormalOk =
            document.getElementById("btnWalletExchangeBetRewardToFormalOk");
          if (uiBtnWalletExchangeBetRewardToFormalOk)
            uiBtnWalletExchangeBetRewardToFormalOk.disabled = false;
        }
      }
    }

    ReplaceTextContent();
  }, [userCoins]);
  //===========================================================================

  function ReplaceTextContent() {
    const language = AppCtrl.getLanguage();
    if (AppCtrl.getCasinoName() == "富二代娛樂城") {
      const uiGiftScoreInput = document.getElementById("giftScoreInput");
      if (uiGiftScoreInput) uiGiftScoreInput.placeholder = "分數，至少1000分";
    }

    if (language == LANGUAGE_TYPE.en_US) {
      // texts for trial to formal
      const uiExchangeTrialToFormal = document.getElementById(
        "ExchangeTrialToFormal"
      );
      if (uiExchangeTrialToFormal)
        uiExchangeTrialToFormal.innerHTML = `Exchange ${Config.silver[language]} to ${Config.gold[language]}`;
      const uiExchangeTrialToFormalGold = document.getElementById(
        "ExchangeTrialToFormalGold"
      );
      if (uiExchangeTrialToFormalGold)
        uiExchangeTrialToFormalGold.innerHTML = `Applied ${Config.gold[language]}`;
      const uiExchangeTrialToFormalSilver = document.getElementById(
        "ExchangeTrialToFormalSilver"
      );
      if (uiExchangeTrialToFormalSilver)
        uiExchangeTrialToFormalSilver.innerHTML = `Requied ${Config.silver[language]}`;

      // texts for formal to trial
      const uiExchangeFormalToTrial = document.getElementById(
        "ExchangeFormalToTrial"
      );
      if (uiExchangeFormalToTrial)
        uiExchangeFormalToTrial.innerHTML = `Exchange ${Config.gold[language]} to ${Config.silver[language]}`;
      const uiExchangeFormalToTrialGold = document.getElementById(
        "ExchangeFormalToTrialGold"
      );
      if (uiExchangeFormalToTrialGold)
        uiExchangeFormalToTrialGold.innerHTML = `Applied ${Config.gold[language]}`;
      const uiExchangeFormalToTrialSilver = document.getElementById(
        "ExchangeFormalToTrialSilver"
      );
      if (uiExchangeFormalToTrialSilver)
        uiExchangeFormalToTrialSilver.innerHTML = `Received ${Config.silver[language]}`;

      // texts for bet reward to formal
      const uiExchangeBetRewardToFormal = document.getElementById(
        "ExchangeBetRewardToFormal"
      );
      if (uiExchangeBetRewardToFormal)
        uiExchangeBetRewardToFormal.innerHTML = `Exchange bet reward to ${Config.gold[language]}`;
    } else {
      // texts for trial to formal
      const uiExchangeTrialToFormal = document.getElementById(
        "ExchangeTrialToFormal"
      );
      if (uiExchangeTrialToFormal)
        uiExchangeTrialToFormal.innerHTML = `將${Config.silver[language]}兌換成${Config.gold[language]}`;

      // texts for formal to trial
      const uiExchangeFormalToTrial = document.getElementById(
        "ExchangeFormalToTrial"
      );
      if (uiExchangeFormalToTrial)
        uiExchangeFormalToTrial.innerHTML = `將${Config.gold[language]}兌換成${Config.silver[language]}`;

      // texts for bet reward to formal
      const uiExchangeBetRewardToFormal = document.getElementById(
        "ExchangeBetRewardToFormal"
      );
      if (uiExchangeBetRewardToFormal)
        uiExchangeBetRewardToFormal.innerHTML = `將返水兌換成${Config.gold[language]}`;
    }
  }

  function componentDidMount() {
    window.addEventListener("resize", onResize);
    onResize();
  }

  function componentDidUpdate() {}

  function componentWillUnmount() {
    window.removeEventListener("resize", onResize);
  }

  function onResize() {
    const deviceWidth = window.innerWidth;
    const deviceHeight = window.innerHeight;

    const uiWalletPage = document.getElementById("walletPage");
    if (uiWalletPage) {
      uiWalletPage.style.height = `${deviceHeight}px`;
      uiWalletPage.style.overflowY = "auto";
    }
  }

  function onRefreshUserScores() {
    AppCtrl.getUserScores();
  }

  function onUserSendGiftOk() {
    try {
      const uiTargetAccountInput = document.getElementById(
        "walletTargetAccountInput"
      );
      const uiGiftScoreInput = document.getElementById("giftScoreInput");

      if (uiTargetAccountInput && uiGiftScoreInput) {
        const language = AppCtrl.getLanguage();
        const targetUserId = uiTargetAccountInput.value;
        const score = parseInt(uiGiftScoreInput.value);
        if (!targetUserId) {
          if (language == LANGUAGE_TYPE.en_US)
            throw new Error("Please input account of receiver");
          else throw new Error("請填寫受贈者帳號");
        }
        if (Number.isNaN(score)) {
          if (language == LANGUAGE_TYPE.en_US)
            throw new Error("Please input the value of point");
          else throw new Error("請填寫欲贈送的分數");
        } else {
          if (AppCtrl.getCasinoName() == "富二代娛樂城" && score < 1000) {
            if (language == LANGUAGE_TYPE.en_US)
              throw new Error("Invalid value");
            else throw new Error("不可低於下限");
          } else if (score < 1) {
            //一般客人
            if (language == LANGUAGE_TYPE.en_US)
              throw new Error("Invalid value");
            else throw new Error("不可低於下限");
          }
        }

        let msgTitle;
        let msgGift;
        let msgYes;
        let msgNo;
        if (language == LANGUAGE_TYPE.en_US) {
          //msgTitle = '*send gift*';
          //msgGift = `send gift to ${targetUserId}? score: ${score}`;
          msgGift = "*send gift*";
          msgTitle = `send gift to ${targetUserId}? score: ${score}`;
          msgYes = "Yes";
          msgNo = "No";
        } else {
          //msgTitle = '*送禮確認*';
          //msgGift = `確定要贈禮給: ${targetUserId} 嗎? => 贈 ${score} 點`;
          msgGift = "*送禮確認*";
          msgTitle = `確定要贈禮給: ${targetUserId} 嗎? => 贈 ${score} 點`;
          msgYes = "確定";
          msgNo = "取消";
        }
        if (Config.giftnotice) {
          for (let i = 0; i < Config.giftnotice.length; i++) {
            let giftnotice = Config.giftnotice[i].notice;
            if (giftnotice != "") msgTitle += giftnotice;
          }
        }

        const confirmCb = function () {
          AppCtrl.userTransferCoins(
            uiGiftScoreInput.value,
            uiTargetAccountInput.value,
            function (resObj) {
              if (resObj.status == "success") {
                showAlert({ title: resObj.message, icon: "success" });
                // AppCtrl.alert(resObj.message, '', 'success', true, 'Ok');
              } else {
                showAlert({ title: resObj.error });
                // AppCtrl.alert(resObj.error);
              }
              // clear
              uiTargetAccountInput.value = "";
              uiGiftScoreInput.value = "";
            }
          );
        };

        showAlert({
          title: msgTitle,
          text: msgGift,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: msgYes,
          cancelButtonText: msgNo,
          confirmCb,
        });
        // Swal.fire({
        //   title: msgTitle,
        //   text: msgGift,
        //   icon: "warning",
        //   showCancelButton: true,
        //   confirmButtonColor: "#d33",
        //   cancelButtonColor: "#3085d6",
        //   confirmButtonText: msgYes,
        //   cancelButtonText: msgNo,
        // }).then(function (result) {
        //   if (result.isConfirmed) {
        //     AppCtrl.userTransferCoins(
        //       uiGiftScoreInput.value,
        //       uiTargetAccountInput.value,
        //       function (resObj) {
        //         if (resObj.status == "success") {
        //           showAlert({ title: resObj.message, icon: "success" });
        //           // AppCtrl.alert(resObj.message, '', 'success', true, 'Ok');
        //         } else {
        //           showAlert({ title: resObj.error });
        //           // AppCtrl.alert(resObj.error);
        //         }
        //         // clear
        //         uiTargetAccountInput.value = "";
        //         uiGiftScoreInput.value = "";
        //       }
        //     );
        //   }
        // });
      }
    } catch (ex) {
      showAlert({ title: ex.message });
      // AppCtrl.alert(ex.message);
    }
  }

  function onChangeExchangeTrialToFormal() {
    const uiWalletExchangeTrialToFormalGolds = document.getElementById(
      "walletExchangeTrialToFormalGolds"
    );
    const uiWalletExchangeTrialToFormalSilvers = document.getElementById(
      "walletExchangeTrialToFormalSilvers"
    );

    if (
      uiWalletExchangeTrialToFormalGolds &&
      uiWalletExchangeTrialToFormalSilvers
    ) {
      const mainSettings = AppCtrl.mainSettings();
      const exchangeRatio = mainSettings.hasOwnProperty("ExchangeRatio")
        ? parseInt(mainSettings["ExchangeRatio"])
        : 1;
      const exchangeReceiverRate = mainSettings.hasOwnProperty(
        "ExchangeReceiverRate"
      )
        ? parseInt(mainSettings["ExchangeReceiverRate"])
        : 100;
      const score = parseInt(uiWalletExchangeTrialToFormalGolds.value);
      let trialCoins = score * exchangeRatio;
      if (exchangeReceiverRate != 100) {
        trialCoins = Math.ceil(
          trialCoins + (trialCoins * (100 - exchangeReceiverRate)) / 100
        );
      }
      uiWalletExchangeTrialToFormalSilvers.value = trialCoins;
    }
  }

  function onChangeExchangeFormalToTrial() {
    const uiWalletExchangeFormalToTrialGolds = document.getElementById(
      "walletExchangeFormalToTrialGolds"
    );
    const uiWalletExchangeFormalToTrialSilvers = document.getElementById(
      "walletExchangeFormalToTrialSilvers"
    );

    if (
      uiWalletExchangeFormalToTrialGolds &&
      uiWalletExchangeFormalToTrialSilvers
    ) {
      const mainSettings = AppCtrl.mainSettings();
      const exchangeRatio = mainSettings.hasOwnProperty("ExchangeRatio")
        ? parseInt(mainSettings["ExchangeRatio"])
        : 1;
      const exchangeReceiverRate = mainSettings.hasOwnProperty(
        "ExchangeReceiverRate"
      )
        ? parseInt(mainSettings["ExchangeReceiverRate"])
        : 100;
      const score = parseInt(uiWalletExchangeFormalToTrialGolds.value);
      let trialCoins = score * exchangeRatio;
      if (exchangeReceiverRate != 100) {
        trialCoins = Math.ceil((trialCoins * exchangeReceiverRate) / 100);
      }
      uiWalletExchangeFormalToTrialSilvers.value = trialCoins;
    }
  }

  function onExchangeTrialToFormalOk() {
    try {
      const uiWalletExchangeTrialToFormalGolds = document.getElementById(
        "walletExchangeTrialToFormalGolds"
      );
      const uiWalletExchangeTrialToFormalSilvers = document.getElementById(
        "walletExchangeTrialToFormalSilvers"
      );

      if (
        uiWalletExchangeTrialToFormalGolds &&
        uiWalletExchangeTrialToFormalSilvers
      ) {
        const language = AppCtrl.getLanguage();
        const score = parseInt(uiWalletExchangeTrialToFormalGolds.value);
        const trialScore = parseInt(uiWalletExchangeTrialToFormalSilvers.value);
        if (Number.isNaN(score)) {
          if (language == LANGUAGE_TYPE.en_US)
            throw new Error("Please input the value of point");
          else throw new Error("請填寫欲兌換的分數");
        } else if (score < 1) {
          //一般客人
          if (language == LANGUAGE_TYPE.en_US) throw new Error("Invalid value");
          else throw new Error("不可低於下限");
        }
        const mainSettings = AppCtrl.mainSettings();
        const exchangeMinLeft = parseInt(mainSettings["ExchangeMinLeft"]);
        //exchangeMinLeft = 20000;
        if (trialScore > userCoins.trialCoins - exchangeMinLeft) {
          if (language == LANGUAGE_TYPE.en_US)
            throw new Error("Your trial score is not enough");
          else throw new Error("可供兌換的銀幣不足");
        }
        //
        AppCtrl.exchangeTrialToFormal(score, (obj) => {
          const status = obj.hasOwnProperty("status")
            ? obj["status"]
            : "failed";
          if (status != "success") {
            const error = obj.hasOwnProperty("error")
              ? obj["error"].toString()
              : "unknown issue";
            showAlert({ title: error });
            // AppCtrl.alert(error);
          }
          uiWalletExchangeTrialToFormalGolds.value = "";
          uiWalletExchangeTrialToFormalSilvers.value = "";
        });
      }
    } catch (ex) {
      showAlert({ title: ex.message });
      // AppCtrl.alert(ex.message);
    }
  }

  function onExchangeFormalToTrialOk() {
    try {
      const uiWalletExchangeFormalToTrialGolds = document.getElementById(
        "walletExchangeFormalToTrialGolds"
      );
      const uiWalletExchangeFormalToTrialSilvers = document.getElementById(
        "walletExchangeFormalToTrialSilvers"
      );

      if (
        uiWalletExchangeFormalToTrialGolds &&
        uiWalletExchangeFormalToTrialSilvers
      ) {
        const language = AppCtrl.getLanguage();
        const score = parseInt(uiWalletExchangeFormalToTrialGolds.value);
        const trialScore = parseInt(uiWalletExchangeFormalToTrialSilvers.value);
        if (Number.isNaN(score)) {
          if (language == LANGUAGE_TYPE.en_US)
            throw new Error("Please input the value of point");
          else throw new Error("請填寫欲兌換的分數");
        } else if (score < 1) {
          //一般客人
          if (language == LANGUAGE_TYPE.en_US) throw new Error("Invalid value");
          else throw new Error("不可低於下限");
        }
        //
        AppCtrl.exchangeFormalToTrial(score, (obj) => {
          const status = obj.hasOwnProperty("status")
            ? obj["status"]
            : "failed";
          if (status != "success") {
            const error = obj.hasOwnProperty("error")
              ? obj["error"].toString()
              : "unknown issue";
            showAlert({ title: error });
            // AppCtrl.alert(error);
          }
          uiWalletExchangeFormalToTrialGolds.value = "";
          uiWalletExchangeFormalToTrialSilvers.value = "";
        });
      }
    } catch (ex) {
      showAlert({ title: ex.message });
      // AppCtrl.alert(ex.message);
    }
  }

  function onChangeExchangeBetRewardToFormal() {
    const uiWalletExchangeBetRewardToFormalGolds = document.getElementById(
      "walletExchangeBetRewardToFormalGolds"
    );
    const uiWalletExchangeBetRewardToFormalBetRewards = document.getElementById(
      "walletExchangeBetRewardToFormalBetRewards"
    );
    const uiBtnWalletExchangeBetRewardToFormalOk = document.getElementById(
      "btnWalletExchangeBetRewardToFormalOk"
    );

    if (
      uiWalletExchangeBetRewardToFormalGolds &&
      uiWalletExchangeBetRewardToFormalBetRewards
    ) {
      const mainSettings = AppCtrl.mainSettings();
      const minExchangeBetReward = mainSettings.MinExchangeBetReward;
      const maxExchangeBetReward = mainSettings.MaxExchangeBetReward;
      const score = parseInt(uiWalletExchangeBetRewardToFormalGolds.value);
      if (score >= minExchangeBetReward && score <= maxExchangeBetReward) {
        uiBtnWalletExchangeBetRewardToFormalOk.disabled = false;
      } else {
        uiBtnWalletExchangeBetRewardToFormalOk.disabled = true;
      }
      uiWalletExchangeBetRewardToFormalBetRewards.value = score;
    }
  }

  function onExchangeBetRewardToFormalOk() {
    try {
      const uiWalletExchangeBetRewardToFormalGolds = document.getElementById(
        "walletExchangeBetRewardToFormalGolds"
      );
      const uiWalletExchangeBetRewardToFormalBetRewards =
        document.getElementById("walletExchangeBetRewardToFormalBetRewards");

      if (
        uiWalletExchangeBetRewardToFormalGolds &&
        uiWalletExchangeBetRewardToFormalBetRewards
      ) {
        const language = AppCtrl.getLanguage();
        const score = parseInt(uiWalletExchangeBetRewardToFormalGolds.value);
        const betRewardScore = parseInt(
          uiWalletExchangeBetRewardToFormalBetRewards.value
        );
        if (Number.isNaN(score)) {
          if (language == LANGUAGE_TYPE.en_US)
            throw new Error("Please input the value of point");
          else throw new Error("請填寫欲兌換的分數");
        } else if (score < 1) {
          //一般客人
          if (language == LANGUAGE_TYPE.en_US) throw new Error("Invalid value");
          else throw new Error("不可低於下限");
        }
        if (betRewardScore > Math.floor(userCoins.betReward)) {
          if (language == LANGUAGE_TYPE.en_US)
            throw new Error("Your bet reward is not enough");
          else throw new Error("可供兌換的返水不足");
        }
        //
        AppCtrl.exchangeBetRewardToFormal(score, (obj) => {
          const status = obj.hasOwnProperty("status")
            ? obj["status"]
            : "failed";
          if (status != "success") {
            const error = obj.hasOwnProperty("error")
              ? obj["error"].toString()
              : "unknown issue";
            showAlert({ title: error });
            // AppCtrl.alert(error);
          } else {
            if (language == LANGUAGE_TYPE.en_US)
              showAlert({
                title: "exchange done",
              });
            // AppCtrl.alert('exchange done');
            else
              showAlert({
                title: "兌換成功",
              });
            // AppCtrl.alert('兌換成功');
          }
          uiWalletExchangeBetRewardToFormalGolds.value = "";
          uiWalletExchangeBetRewardToFormalBetRewards.value = "";
        });
      }
    } catch (ex) {
      showAlert({ title: ex.message });
      // AppCtrl.alert(ex.message);
    }
  }

  function onBack() {
    //AppCtrl.askMachineTokenInLobby();
    setFunc(EFunction.winLobby);
    // navigate('/lobby');
  }

  return (
    <div id="walletPage" className={styles.walletPage}>
      <div className={styles.mainArea}>
        <h3>{`${text.wallet}`}</h3>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            textAlign: "left",
            fontSize: "18px",
            width: "100%",
            height: "120px",
            color: "white",
          }}
        >
          <div style={{ margin: "0px 10px", width: "60%", textAlign: "left" }}>
            {/* current time (red box) */}
            <div id="walletNowTime" style={{ fontSize: "14px", marginBottom: 4 }}>
              {AppCtrl.getLanguage() === LANGUAGE_TYPE.en_US ? "Now: " : "現在時間："}
              {nowTime.format("YYYY/MM/DD HH:mm:ss")}
            </div>
            <div id="walletUserName"></div>
            <div id="walletUserScores"></div>
            <div id="walletUserTrialScores"></div>
            <div id="walletUserWainZhus"></div>
            <div id="walletBetReward"></div>
          </div>
          <div style={{ margin: "0px 10px", width: "40%", textAlign: "right" }}>
            <button
              className="large red button"
              style={{
                margin: "5px auto",
                width: "80%",
                height: "50px",
                maxWidth: "160px",
                fontSize: "16px",
              }}
              onClick={onBack}
            >{`${text.back}`}</button>
            <button
              className="large green button"
              style={{
                margin: "5px auto",
                width: "80%",
                height: "50px",
                maxWidth: "160px",
                fontSize: "16px",
              }}
              onClick={onRefreshUserScores}
            >{`${text.refresh}`}</button>
          </div>
        </div>
        <hr></hr>
         <div>
          <h3>{`${text.gift}`}</h3>
          <div
            style={{
              textAlign: "left",
              fontSize: "14px",
              width: "100%",
              color: "white",
            }}
          >{`${text.receiverSP}:`}</div>
          <div style={{ margin: "10 auto", width: "100%" }}>
            <input
              id="walletTargetAccountInput"
              type="text"
              style={{
                width: "80%",
                fontSize: "18px",
                height: "30px",
                textAlign: "center",
                color: "black",
              }}
              placeholder={`${text.receiverPlaceholder}`}
            />
          </div>
          <div
            style={{
              textAlign: "left",
              fontSize: "14px",
              width: "100%",
              color: "white",
            }}
          >{`${text.giftScoreSP}:`}</div>
          <div style={{ margin: "10 auto", width: "100%" }}>
            <input
              id="giftScoreInput"
              type="number"
              style={{
                width: "80%",
                fontSize: "18px",
                height: "30px",
                textAlign: "center",
                color: "black",
              }}
              placeholder={`${text.giftScorePlaceholder}`}
            />
          </div>
          <div style={{ paddingTop: "10px" }}>
            <button
              className="large blue button"
              style={{ width: "48%", height: "40px", fontSize: "18px" }}
              onClick={onUserSendGiftOk}
            >{`${text.confirm}`}</button>
          </div>
          <hr></hr>
        </div>
        {canExchangeTrialToFormal ? (
          <div>
            <span
              id="walletExchangeTrialToFormalHint"
              style={{ float: "right", textAlign: "right", fontSize: "12px" }}
            ></span>
            <h3 id="ExchangeTrialToFormal"></h3>
            <div
              id="ExchangeTrialToFormalGold"
              style={{
                textAlign: "left",
                fontSize: "14px",
                width: "100%",
                color: "white",
              }}
            >{`${text.appliedGolds}:`}</div>
            <div style={{ margin: "10 auto", width: "100%" }}>
              <input
                id="walletExchangeTrialToFormalGolds"
                type="number"
                style={{
                  width: "80%",
                  fontSize: "18px",
                  height: "30px",
                  textAlign: "center",
                  color: "black",
                }}
                placeholder={`${text.appliedGoldsPlaceholder}`}
                onChange={onChangeExchangeTrialToFormal}
              />
            </div>
            <div
              id="ExchangeTrialToFormalSilver"
              style={{
                textAlign: "left",
                fontSize: "14px",
                width: "100%",
                color: "white",
              }}
            >{`${text.consumedSilver}:`}</div>
            <div style={{ margin: "10 auto", width: "100%" }}>
              <input
                id="walletExchangeTrialToFormalSilvers"
                type="number"
                style={{
                  width: "80%",
                  fontSize: "18px",
                  height: "30px",
                  textAlign: "center",
                  color: "black",
                }}
                disabled
              />
            </div>
            <div style={{ paddingTop: "10px" }}>
              <button
                id="btnWalletExchangeTrialToFormalOk"
                className="large blue button"
                style={{ width: "48%", height: "40px", fontSize: "18px" }}
                onClick={onExchangeTrialToFormalOk}
              >{`${text.confirm}`}</button>
            </div>
            <hr></hr>
          </div>
        ) : null}
        {canExchangeFormalToTrial ? (
          <div>
            <span
              id="walletExchangeFormalToTrialHint"
              style={{ float: "right", textAlign: "right", fontSize: "12px" }}
            ></span>
            <h3 id="ExchangeFormalToTrial"></h3>
            <div
              id="ExchangeFormalToTrialGold"
              style={{
                textAlign: "left",
                fontSize: "14px",
                width: "100%",
                color: "white",
              }}
            >{`${text.appliedGolds}:`}</div>
            <div style={{ margin: "10 auto", width: "100%" }}>
              <input
                id="walletExchangeFormalToTrialGolds"
                type="number"
                style={{
                  width: "80%",
                  fontSize: "18px",
                  height: "30px",
                  textAlign: "center",
                  color: "black",
                }}
                placeholder={`${text.appliedGoldsPlaceholder}`}
                onChange={onChangeExchangeFormalToTrial}
              />
            </div>
            <div
              id="ExchangeFormalToTrialSilver"
              style={{
                textAlign: "left",
                fontSize: "14px",
                width: "100%",
                color: "white",
              }}
            >{`${text.exchangedSilver}:`}</div>
            <div style={{ margin: "10 auto", width: "100%" }}>
              <input
                id="walletExchangeFormalToTrialSilvers"
                type="number"
                style={{
                  width: "80%",
                  fontSize: "18px",
                  height: "30px",
                  textAlign: "center",
                  color: "black",
                }}
                disabled
              />
            </div>
            <div style={{ paddingTop: "10px" }}>
              <button
                id="btnWalletExchangeFormalToTrialOk"
                className="large blue button"
                style={{ width: "48%", height: "40px", fontSize: "18px" }}
                onClick={onExchangeFormalToTrialOk}
              >{`${text.confirm}`}</button>
            </div>
            <hr></hr>
          </div>
        ) : null}
        {canExchangeBetRewardToFormal ? (
          <div id="walletExchangeBetRewardToFormal">
            <span
              id="walletExchangeBetRewardToFormalHint"
              style={{ float: "right", textAlign: "right", fontSize: "12px" }}
            ></span>
            <h3 id="ExchangeBetRewardToFormal"></h3>
            <div
              style={{
                textAlign: "left",
                fontSize: "14px",
                width: "100%",
                color: "white",
              }}
            >{`${text.appliedGolds}:`}</div>
            <div style={{ margin: "10 auto", width: "100%" }}>
              <input
                id="walletExchangeBetRewardToFormalGolds"
                type="number"
                style={{
                  width: "80%",
                  fontSize: "18px",
                  height: "30px",
                  textAlign: "center",
                  color: "black",
                }}
                onChange={onChangeExchangeBetRewardToFormal}
              />
            </div>
            <div
              style={{
                textAlign: "left",
                fontSize: "14px",
                width: "100%",
                color: "white",
              }}
            >{`${text.consumedBetReward}:`}</div>
            <div style={{ margin: "10 auto", width: "100%" }}>
              <input
                id="walletExchangeBetRewardToFormalBetRewards"
                type="number"
                style={{
                  width: "80%",
                  fontSize: "18px",
                  height: "30px",
                  textAlign: "center",
                  color: "black",
                }}
                disabled
              />
            </div>
            <div style={{ paddingTop: "10px" }}>
              <button
                id="btnWalletExchangeBetRewardToFormalOk"
                className="large blue button"
                style={{ width: "48%", height: "40px", fontSize: "18px" }}
                onClick={onExchangeBetRewardToFormalOk}
              >{`${text.confirm}`}</button>
            </div>
            <hr></hr>
          </div>
        ) : null} 
      </div>
    </div>
  );
}

export default WalletPage;
